export let defaultRelaysToPublish = [
  "wss://nostr-pub.wellorder.net/",
  "wss://relay.nostr.scot",
  // "ws://localhost:8080",
];

export let defaultRelays = [
  "wss://nos.lol",
  "wss://relay.damus.io",
  "wss://arnostr.permadao.io",
  "wss://relay.snort.social",
  // "ws://localhost:8080",
];
